module.exports = __webpack_public_path__ + "images/jobs/coins.b91dacd0.svg";